import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import Login from '@/components/login/Login'
import Drawer from '@/components/drawer/Drawer'
import Home from '@/components/home/Home'
import TaskList from '@/components/task/TaskList'
import TaskController from '@/components/task/TaskController'
import ProcessList from '@/components/process/ProcessList'
import ProcessSearch from '@/components/process/ProcessSearch'
import ProcessStartController from '@/components/process/ProcessStartController'
import ProcessInfoController from '@/components/process/ProcessInfoController'
import ReportList from '@/components/report/ReportList'
import ReportController from '@/components/report/ReportController'
import DashBoardController from '@/components/report/DashBoardController'
import NewsList from '@/components/news/NewsList'
import NewsController from '@/components/news/NewsController'

import SettingsProfile from '@/components/settings/SettingsProfile'
import Contracts from '@/components/contracts/Contracts'
import Activity from '@/components/activity/Activity'
import Ski from '@/components/activity/Ski'

Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/task-list',
    name: 'Drawer',
    component: Drawer,
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home,
      },
      {
        path: '/task-list',
        name: 'TaskList',
        component: TaskList,
        beforeEnter: (to, from, next) => {
          (async() => {
            try {
              if (store.getters['task/filter'] === null) {
                await store.dispatch('task/getFilters')
                await store.dispatch('task/selectFilter', store.getters['task/filters'][0])
                await store.dispatch('task/getTasks')
                next()
              } else {
                await store.dispatch('task/getTasks')
                next()
              }
            } catch (error) {
              console.error(error)
              next('/home')
            }
          })()
        },
      },
      {
        path: '/task/:taskId',
        name: 'TaskController',
        component: TaskController,
        props: true,
        beforeEnter: (to, from, next) => {
          store
            .dispatch('task/getTask', to.params.taskId)
            .then(() => {
              next()
            })
            .catch(() => {
              next('/home')
            })
        },
      },
      {
        path: '/process-list',
        name: 'ProcessList',
        component: ProcessList,
      },
      {
        path: '/process-definition/:definitionId',
        name: 'ProcessStartController',
        component: ProcessStartController,
        props: true,
        beforeEnter: (to, from, next) => {
          store
            .dispatch('process/selectDefinition', to.params.definitionId)
            .then(() => {
              next()
            })
            .catch(() => {
              next('/home')
            })
        },
      },
      {
        path: '/process-instance/:instanceId',
        name: 'ProcessInfoController',
        component: ProcessInfoController,
        props: true,
        beforeEnter: (to, from, next) => {
          store
            .dispatch('process/selectInstance', to.params.instanceId)
            .then(() => {
              next()
            })
            .catch(() => {
              next('/home')
            })
        },
      },
      {
        path: '/process-search',
        name: 'ProcessSearch',
        component: ProcessSearch,
      },
      {
        path: '/contracts',
        name: 'Contracts',
        component: Contracts,
      },
      {
        path: '/activity',
        name: 'Activity',
        component: Activity,
      },
      {
        path: '/ski',
        name: 'Ski',
        component: Ski,
      },
      {
        path: '/report-list',
        name: 'ReportList',
        component: ReportList,
      },
      {
        path: '/report/:reportId',
        name: 'ReportController',
        component: ReportController,
        props: true,
      },
      {
        path: '/details/:reportId/:query',
        name: 'DashBoardController',
        component: DashBoardController,
        props: true,
      },
      {
        path: '/profile',
        name: 'SettingsProfile',
        component: SettingsProfile,
      },
      {
        path: '/news-list',
        name: 'NewsList',
        component: NewsList
      },
      {
        path: '/news/:newsId',
        name: 'NewsController',
        component: NewsController,
        props: true,
        beforeEnter: (to, from, next) => {
          store
            .dispatch('task/getTask', to.params.newsId)
            .then(() => {
              next()
            })
            .catch(() => {
              next('/home')
            })
        },
      },
    ],
  },
  { path: '*', redirect: '/home' },
]

const router = new Router({
  routes,
  mode: 'history',
  onError(e) {
    console.error('Router Error', e)
  },
})

router.beforeEach((to, from, next) => {
  const authenticated = store.getters['auth/authenticated']
  if (!authenticated) {
    store.dispatch('auth/authenticate', { to: to, from: from, next: next })
  } else if (to.meta.groups) {
    store.dispatch('auth/checkGroupPermission', { to: to, from: from, next: next })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js